import React from 'react';
import PropTypes from 'prop-types';
import { Button as MUIButton } from '@mui/material';

const Button = ({ children, ...props }) => {

  return (
    <MUIButton {...props}><span>{children}</span></MUIButton>
  );
}


Button.propTypes = {
  children: PropTypes.node,
};

export default Button;
